import { isFunction } from '../lib/helperFunctions';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const RequestSwitch = ({
  children = null,
  components,
  request
}) => {
  if (request && request.requestState) {
    const component = components && components[request.requestState];
    const finalComponent = isFunction(component) ? component({}) : component;
    return /*#__PURE__*/_jsx(_Fragment, {
      children: finalComponent || children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default RequestSwitch;